import React, { useState, useEffect } from "react";
import { Bar } from 'react-chartjs-2';
import { calcTotalLevel } from '../../includes/utilities';

const ProgressBarChart = ({selectedPeriods}) => {

    const [labels, setLabels] = useState([]);
    const [datasets, setDatasets] = useState([]);

    useEffect(() => {

        if (!selectedPeriods || selectedPeriods.length < 1) {
            return;
        }

        const newLabels = [];
        const newDatasets = [];
        const startsAt = [];

        // for each selected period
        selectedPeriods.forEach((period, i) => {

            if (!period.assessment) {
                return;
            }
            
            const data = [];

            Object.keys(period.assessment).forEach((areaKey) => {
                period.assessment[areaKey].topics.forEach((topic, topicIndex) => {

                    // collect labels & starts at data first time round
                    if (i === 0) {
                        newLabels.push(topic.label);
                        startsAt.push(topic['starts-at'] -1);
                    }

                    // calc total level for this topic
                    const level = calcTotalLevel(topic.level, topic['starts-at'])

                    // collect data
                    data.push(level);
                })
            })

            newDatasets.push({
                label: `${period.period_name} ${period.calendar_year}`,
                data: data,
                backgroundColor: (context) => {
                    if (period.period_name == 'Baseline') {
                        const ctx = context.chart.ctx;
                        const gradient = ctx.createLinearGradient(0, 0, 0, 350);
                        gradient.addColorStop(0, "#60579590");
                        gradient.addColorStop(1, "#60579550");
                        return gradient;
                    }
                    else if (i === selectedPeriods.length - 1) {
                        const ctx = context.chart.ctx;
                        const gradient = ctx.createLinearGradient(0, 0, 0, 350);
                        gradient.addColorStop(0, "rgba(1, 115, 50, 1)");
                        gradient.addColorStop(1, "rgba(1, 115, 50, 0.5)");
                        return gradient;
                    } else {
                        const ctx = context.chart.ctx;
                        const gradient = ctx.createLinearGradient(0, 0, 0, 350);
                        gradient.addColorStop(0, "rgba(1, 115, 50, 0.8)");
                        gradient.addColorStop(1, "rgba(1, 115, 50, 0.2)");
                        return gradient;
                    }
                },
                borderColor: 'rgba(60, 80, 99, 0.3)',
                borderWidth: 1,
                borderRadius: 6
            });
        });

        newDatasets.push({
            label: 'Topic starts at',
            data: startsAt,
            backgroundColor: (context) => {
                const ctx = context.chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, 350);
                gradient.addColorStop(0, "rgba(170, 170, 170, 1)");
                gradient.addColorStop(1, "rgba(170, 170, 170, 1)");
                return gradient;
            },
            borderRadius: 6,
            categoryPercentage: 0.85,
            grouped: false,
            order: -1
        })

        setLabels(newLabels);
        setDatasets(newDatasets);

    }, [selectedPeriods])

    return (
        <>
            {labels && datasets && 
                <Bar
                    data={{
                        labels: labels,
                        datasets: datasets
                    }}
                    options={{
                        scales: {
                            y: {
                                max: 6,
                                title: {
                                    display: true,
                                    text: 'Level'
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true
                            }
                        }
                    }}
                />
            }
        </>
    )
}

export default ProgressBarChart;